import { ElementType, HTMLAttributes, ReactNode } from "react";
import { twMerge } from 'tailwind-merge'

interface ElementProps extends HTMLAttributes<HTMLDivElement> {
    icon?: ElementType,
    text?: string,
    children: ReactNode
}

export function Row({ icon: Icon, text, children, ...rest }: ElementProps) {
    return (
        <div
            {...rest}
            className={twMerge("tw-flex tw-flex-col lg:tw-flex-row tw-items-end tw-gap-8 tw-mt-5", rest.className)}
        >
            {children}
        </div>
    )
}